import { getItemFromCollection } from "directus/src/operations";
import { queryClient } from "utils/react-query";

const collection = "companies";

export async function getCompany({ companyId }) {
  try {
    const data = await getItemFromCollection("companies", companyId);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export function invalidateAllCompaniesQueries() {
    queryClient.invalidateQueries({
        predicate: ({ queryKey }) => queryKey[0] === collection,
    });
}
